var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"mt-4",attrs:{"loading":_vm.isSaving,"disabled":_vm.isSaving},on:{"click":_vm.handleSave}},[_vm._v("Save")])}
var staticRenderFns = []

export { render, staticRenderFns }